import React from "react";
import { Container, Row, Col, Button } from 'reactstrap';
import EpkPage from "./EpkPage";
import MainLayout from "../layout/MainLayout";
import Icon from "../custom/Icon";
import { Link } from "react-router-dom";
import { Path } from "../container/Path";

export default class NotFoundPage extends EpkPage {

    constructor(props) {
        super(props);
    }

    pageTitle() {
        return "Stranica nije pronađena - " + process.env.REACT_APP_TITLE_PREFIX;
    }

    pageLayout() {
        return new MainLayout();
    }

    getDestroyableMembers() {
        return [];
    }

    renderContent() {

        return (
            <>
                <div className="epk-404-content">
                    <Container>
                        <div className="epk-404-section epk-section">
                            <Row>
                                <Col md="12" className="error-icon">
                                    <Icon name="404" />
                                </Col>
                                <Col md="12">
                                    <h1 className="epk-container-h1">GREŠKA 404</h1>
                                </Col>
                                <Col md="12">
                                    <div className="content">
                                        <p>Ova stranica ne postoji</p>
                                        <Button tag={Link} to={Path.HOMEPAGE} color="primary">Vrati se na početnu</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
            </>
        );
    }
}
